import { render, staticRenderFns } from "./ContactDefault.vue?vue&type=template&id=53c842dd&scoped=true&"
import script from "./ContactDefault.vue?vue&type=script&lang=js&"
export * from "./ContactDefault.vue?vue&type=script&lang=js&"
import style0 from "./ContactDefault.vue?vue&type=style&index=0&id=53c842dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c842dd",
  null
  
)

export default component.exports